
@if (displayToast) {
  <div id="toast">
    <app-toast toastStyle="positive" icon="checkmark" [text]="successResponse">
    </app-toast>
  </div>
}
@if (showMorbidostatWarning()) {
  <div id="morbidostat-toast">
    <app-toast
      toastStyle="warning"
      icon="warning"
      text="Morbidostat mode requires external pump module"
    ></app-toast>
  </div>
}
@if (!getExperimentError) {
  <div id="title--container">
    <h4>Select Devices</h4>
    @if (error) {
      <span class="error">{{ error?.message }} </span>
    }
    <h5>{{ laboratory.laboratoryName }}</h5>
  </div>
  <hr />
  <div id="action--toolbar">
    <div id="actions">
      <app-mat-icon-button
        buttonStyle="primary"
        buttonId="remove-btn"
        iconName="arrow_back"
        ariaLabel="Back"
        (buttonClicked)="goBack()"
        [isDisabled]="
          experiment?.experimentStatusId === ExperimentStatus.DraftLocked ||
          !hasEditAccess
        "
      ></app-mat-icon-button>
      <div id="experiment-name">
        <h6>
          {{ experiment?.name }}
        </h6>
        @if (experiment) {
          <app-status-indicator
            [status]="ExperimentStatus[experiment?.experimentStatusId]"
          ></app-status-indicator>
        }
      </div>
      <app-icon-button
        label="delete draft"
        buttonStyle="negative"
        buttonId="delete-draft-btn"
        iconName="delete"
        buttonShape="square"
        (click)="openModal('delete-draft')"
        [isDisabled]="
          deleteIsProcessing ||
          !(currentUser.role
            | roleCheck: labAdminRoles)
        "
      ></app-icon-button>
    </div>
    <hr />
  </div>
  <div id="inner-page--container">
    <div id="calibration--container">
      @if (experiment?.experimentStatusId === ExperimentStatus.Draft) {
        <div id="add-device--container">
          <h6>Add Device</h6>
          <div class="add-device-form--container">
            <div class="selected-devices--container">
              @if (
                !devicesLoading &&
                !deviceError &&
                availableDeviceList.length > 0
              ) {
                <app-dropdown-form-field
                  [field]="deviceSelectField"
                  [parentForm]="experimentSetupForm"
                ></app-dropdown-form-field>
              }
              @if (
                !deviceError &&
                !devicesLoading &&
                availableDeviceList.length === 0
              ) {
                <span class="body1">No devices available</span>
              }
              @if (deviceError) {
                <span class="error">{{ deviceError.message }}</span>
              }
              @if (devicesLoading) {
                <div class="body1">
                  <app-small-loading-spinner></app-small-loading-spinner>
                </div>
              }
            </div>
            <app-slide-toggle
              [parentForm]="deviceFilterForm"
              [field]="inactiveDeviceToggleField"
            ></app-slide-toggle>
            <app-slide-toggle
              [parentForm]="deviceFilterForm"
              [field]="onlineDeviceToggleField"
            ></app-slide-toggle>
          </div>
        </div>
        <hr />
      }
      @if (selectedDeviceList.length > 0) {
        <div id="selected-devices--container">
          <h6>Selected Devices</h6>
          <div class="device-selection--container">
            <form [formGroup]="experimentSetupForm">
              @for (
                device of selectedDeviceList;
                track device.deviceId;
                let idx = $index
              ) {
                <div class="device-card">
                  <div class="card-title-container">
                    <div class="title">
                      <span class="subtitle2">
                        {{ device.deviceName }}
                      </span>
                      @if (!device.isOffline) {
                        <mat-icon class="online">wifi</mat-icon>
                      }
                      @if (device.isOffline) {
                        <mat-icon class="offline">wifi_off</mat-icon>
                      }
                    </div>
                    <app-mat-icon-button
                      buttonStyle="warn"
                      buttonId="remove-btn"
                      iconName="close"
                      ariaLabel="Back"
                      (buttonClicked)="handleRemoveDevices(device.deviceId)"
                      [isDisabled]="
                        experiment?.experimentStatusId ===
                          ExperimentStatus.DraftLocked || !hasEditAccess
                      "
                    ></app-mat-icon-button>
                  </div>
                  <div class="status-container body1">
                    <div class="status">
                      Device status:
                      <app-status-indicator
                        [status]="DeviceSetupStatus[device.deviceStatusId]"
                      ></app-status-indicator>
                    </div>
                  </div>
                  <div class="pump-tube-container body1">
                    @if (requiredDeviceModules.has(Module.LiquidControl)) {
                      @if (device.pumpTubeLength) {
                        Pump tube length: {{ device.pumpTubeLength }} cm
                        <app-mat-icon-button
                          buttonStyle="primary"
                          buttonId="set-pump-tube-length-btn"
                          iconName="edit"
                          ariaLabel="Edit"
                          [routerLink]="['/device', device.deviceId, 'details']"
                        ></app-mat-icon-button>
                      } @else {
                        @if (
                          experiment?.experimentStatusId !==
                          ExperimentStatus.DraftLocked
                        ) {
                          Please set pump tube length
                          <app-mat-icon-button
                            buttonStyle="primary"
                            buttonId="set-pump-tube-length-btn"
                            iconName="edit"
                            ariaLabel="Edit"
                            [routerLink]="[
                              '/device',
                              device.deviceId,
                              'details',
                            ]"
                          ></app-mat-icon-button>
                        }
                      }
                    }
                  </div>
                  <div class="device-form--container">
                    <div class="op-density--container">
                      @if (device.calibrationList.length > 0) {
                        <app-dynamic-dropdown-form-field
                          [parentForm]="experimentSetupForm"
                          [device]="device"
                          placeholder="Select OD Calibration"
                        ></app-dynamic-dropdown-form-field>
                      }
                      @if (
                        !odError &&
                        !odCalibrationLoading &&
                        (!device.calibrationList ||
                          device.calibrationList.length === 0)
                      ) {
                        <div class="no-calibrations">
                          <mat-icon class="red-icon">error</mat-icon>
                          <span class="body1">
                            No optical density calibrations
                          </span>
                        </div>
                      }
                      @if (odError) {
                        <span class="error">{{ odError.message }}</span>
                      }
                      @if (odCalibrationLoading) {
                        <div class="body1">
                          <app-small-loading-spinner></app-small-loading-spinner>
                        </div>
                      }
                    </div>
                    @if (experiment.useOxygen) {
                      <div class="ox-cal--container">
                        @if (device.oxygenCalibrationList?.length > 0) {
                          <app-dynamic-dropdown-form-field
                            [parentForm]="experimentSetupForm"
                            [device]="device"
                            [calibrationType]="1"
                            placeholder="Select Oxygen Calibration"
                          ></app-dynamic-dropdown-form-field>
                        }
                        @if (
                          !oxyError &&
                          !oxygenCalibrationLoading &&
                          (!device.oxygenCalibrationList ||
                            device.oxygenCalibrationList?.length === 0)
                        ) {
                          <div class="no-calibrations">
                            <mat-icon class="red-icon">error</mat-icon>
                            <span class="body1"> No oxygen calibrations </span>
                          </div>
                        }
                        @if (oxyError) {
                          <span class="error">{{ oxyError.message }}</span>
                        }
                        @if (oxygenCalibrationLoading) {
                          <div class="body1">
                            <app-small-loading-spinner></app-small-loading-spinner>
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="module-not-selected">
                        <mat-icon>information</mat-icon>
                        <span class="body1">Oxygen module not selected</span>
                      </div>
                    }
                    @if (experiment.usePH) {
                      <div class="ph-cal--container">
                        @if (device.pHCalibrationList?.length > 0) {
                          <app-dynamic-dropdown-form-field
                            [parentForm]="experimentSetupForm"
                            [device]="device"
                            [calibrationType]="6"
                            placeholder="Select pH Calibration"
                          ></app-dynamic-dropdown-form-field>
                        }
                        @if (
                          !pHError &&
                          !pHCalibrationLoading &&
                          (!device.pHCalibrationList ||
                            device.pHCalibrationList?.length === 0)
                        ) {
                          <div class="no-calibrations">
                            <mat-icon class="red-icon">error</mat-icon>
                            <span class="body1"> No pH calibrations </span>
                          </div>
                        }
                        @if (pHError) {
                          <span class="error">{{ pHError.message }}</span>
                        }
                        @if (pHCalibrationLoading) {
                          <div class="body1">
                            <app-small-loading-spinner></app-small-loading-spinner>
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="module-not-selected">
                        <mat-icon>information</mat-icon>
                        <span class="body1">pH module not selected</span>
                      </div>
                    }
                    @if (experiment.useSparging) {
                      <div class="sparging-cal--container">
                        @if (device.spargingCalibrationList?.length > 0) {
                          <app-dynamic-dropdown-form-field
                            [parentForm]="experimentSetupForm"
                            [device]="device"
                            [calibrationType]="4"
                            placeholder="Select Sparging Calibration"
                          ></app-dynamic-dropdown-form-field>
                        }
                        @if (
                          !spargingError &&
                          !spargingCalibrationLoading &&
                          (!device.spargingCalibrationList ||
                            device.spargingCalibrationList?.length === 0)
                        ) {
                          <div class="no-calibrations">
                            <mat-icon class="red-icon">error</mat-icon>
                            <span class="body1">
                              No sparging calibrations
                            </span>
                          </div>
                        }
                        @if (spargingError) {
                          <span class="error">{{ spargingError.message }}</span>
                        }
                        @if (spargingCalibrationLoading) {
                          <div class="body1">
                            <app-small-loading-spinner></app-small-loading-spinner>
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="module-not-selected">
                        <mat-icon>information</mat-icon>
                        <span class="body1">Sparging module not selected</span>
                      </div>
                    }
                  </div>
                </div>
              }
            </form>
          </div>
          @if (experiment?.experimentStatusId === ExperimentStatus.Draft) {
            <div id="save-btn--container">
              <div id="save-btns">
                <app-button
                  label="discard changes"
                  buttonId="discard-btn"
                  buttonStyle="yellow"
                  (buttonClicked)="onDiscardChanges()"
                  [isDisabled]="
                    deleteIsProcessing ||
                    experimentSetupForm.pristine ||
                    !hasEditAccess
                  "
                ></app-button>
                <app-button
                  label="save devices"
                  buttonId="save-btn"
                  (buttonClicked)="onSaveDevices()"
                  [isProcessing]="saveDevicesIsProcessing"
                  [isDisabled]="
                    experimentSetupForm.invalid ||
                    !hasEditAccess ||
                    (experimentSetupForm.pristine && !hasDevicesToRemove) ||
                    saveDevicesIsProcessing
                  "
                ></app-button>
              </div>
            </div>
          } @else {
            <div id="next-btn--container">
              <app-button
                label="go to dashboard"
                buttonId="go-to-dashboard"
                buttonStyle="positive"
                (buttonClicked)="goToDashboard()"
              ></app-button>
              <app-button
                label="Set up devices"
                buttonId="set-devices-btn"
                (buttonClicked)="setUpDevices()"
              ></app-button>
            </div>
          }
        </div>
        @if (
          experiment?.experimentStatusId === ExperimentStatus.Draft &&
          experiment?.useSparging
        ) {
          <hr />
        }
        @if (
          experiment?.experimentStatusId === ExperimentStatus.Draft &&
          experiment?.useSparging &&
          displaySpargingParams
        ) {
          <div id="sparging--container">
            <h6>Sparging Parameters</h6>
            <div class="sparging-fields--container">
              <div class="button-header">
                <app-mat-outlined-button
                  label="Copy A to B, C, D"
                  ariaLabel="Copy A to B, C, D"
                  buttonId="airflow-copy-btn"
                  id="airflow-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyAirflowValues()"
                  [isDisabled]="!hasEditAccess"
                ></app-mat-outlined-button>
              </div>
              <div class="sparging-row">
                <app-number-form-field
                  [parentForm]="spargingForm"
                  [field]="airflowAField"
                  [minValue]="minAirflow"
                  [maxValue]="maxAirflow"
                  [step]="airflowStep"
                  [warningMessage]="airflowRateWarningMessage"
                  [showWarning]="
                    spargingForm.controls['airflowA'].value >
                    airflowWarningValue
                  "
                ></app-number-form-field>
                @if (
                  experiment?.spargingControlTypeA === SpargingStatus.Disabled
                ) {
                  <div class="edit-container">
                    <span class="body1"> Edit control type </span>
                    <app-mat-icon-button
                      iconName="edit"
                      (buttonClicked)="goBack()"
                      ariaLabel="Edit"
                    ></app-mat-icon-button>
                  </div>
                }
              </div>
              <div class="sparging-row">
                <app-number-form-field
                  [parentForm]="spargingForm"
                  [field]="airflowBField"
                  [minValue]="minAirflow"
                  [maxValue]="maxAirflow"
                  [step]="airflowStep"
                  [warningMessage]="airflowRateWarningMessage"
                  [showWarning]="
                    spargingForm.controls['airflowB'].value >
                    airflowWarningValue
                  "
                ></app-number-form-field>
                @if (
                  experiment?.spargingControlTypeB === SpargingStatus.Disabled
                ) {
                  <div class="edit-container">
                    <span class="body1"> Edit control type </span>
                    <app-mat-icon-button
                      iconName="edit"
                      (buttonClicked)="goBack()"
                      ariaLabel="Edit"
                    ></app-mat-icon-button>
                  </div>
                }
              </div>
              <div class="sparging-row">
                <app-number-form-field
                  [parentForm]="spargingForm"
                  [field]="airflowCField"
                  [minValue]="minAirflow"
                  [maxValue]="maxAirflow"
                  [step]="airflowStep"
                  [warningMessage]="airflowRateWarningMessage"
                  [showWarning]="
                    spargingForm.controls['airflowC'].value >
                    airflowWarningValue
                  "
                ></app-number-form-field>
                @if (
                  experiment?.spargingControlTypeC === SpargingStatus.Disabled
                ) {
                  <div class="edit-container">
                    <span class="body1"> Edit control type </span>
                    <app-mat-icon-button
                      iconName="edit"
                      (buttonClicked)="goBack()"
                      ariaLabel="Edit"
                    ></app-mat-icon-button>
                  </div>
                }
              </div>
              <div class="sparging-row">
                <app-number-form-field
                  [parentForm]="spargingForm"
                  [field]="airflowDField"
                  [minValue]="minAirflow"
                  [maxValue]="maxAirflow"
                  [step]="airflowStep"
                  [warningMessage]="airflowRateWarningMessage"
                  [showWarning]="
                    spargingForm.controls['airflowD'].value >
                    airflowWarningValue
                  "
                ></app-number-form-field>
                @if (
                  experiment?.spargingControlTypeD === SpargingStatus.Disabled
                ) {
                  <div class="edit-container">
                    <span class="body1"> Edit control type </span>
                    <app-mat-icon-button
                      iconName="edit"
                      (buttonClicked)="goBack()"
                      ariaLabel="Edit"
                    ></app-mat-icon-button>
                  </div>
                }
              </div>
            </div>
            <div id="sparging-btn--container">
              <app-button
                label="save parameters"
                buttonId="save-sparging-btn"
                (buttonClicked)="onSaveSpargingParameters()"
                [isProcessing]="spargingIsProcessing"
                [isDisabled]="
                  spargingForm.invalid ||
                  !hasEditAccess ||
                  spargingIsProcessing ||
                  spargingForm.pristine
                "
              ></app-button>
            </div>
          </div>
        }
        <hr />
        @if (experiment?.experimentStatusId === ExperimentStatus.Draft) {
          <div id="lock-btn--container">
            <app-button
              label="lock draft"
              buttonId="draft-lock-btn"
              buttonStyle="positive"
              (buttonClicked)="onLockDraft()"
              [isDisabled]="
                experimentSetupForm.dirty ||
                !hasEditAccess ||
                selectedDeviceList.length === 0 ||
                experimentSetupForm.invalid ||
                validSpargingValues()
              "
            ></app-button>
          </div>
        }
      }
    </div>
  </div>
} @else {
  <app-error-page
    [primaryText]="getExperimentError?.message"
  ></app-error-page>
}
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="error?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-validation-modal
  id="delete-draft"
  titleText="Delete draft?"
  validationText="delete"
  primaryButtonText="Confirm delete"
  primaryButtonId="confirm-delete-button"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-delete-button"
  (modalButtonClicked)="deleteDraft()"
  [error]="deleteError"
></app-validation-modal>
<app-modal
  id="delete-success"
  titleText="Success"
  primaryText="Experiment draft was deleted."
  primaryButtonText="Go to dashboard"
  primaryButtonId="delete-success-button"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
  [allowClose]="false"
>
</app-modal>
<app-modal
  id="delete-error"
  titleText="Unable to delete draft"
  [primaryText]="deleteError?.message + '. Choose an action below'"
  buttonLayout="double-button"
  primaryButtonText="Go to dashboard"
  primaryButtonId="error-primary-button"
  secondaryButtonText="Close"
  secondaryButtonId="error-secondary-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
  [allowClose]="false"
>
</app-modal>
<app-modal
  id="lock-success"
  titleText="Draft Locked"
  buttonLayout="double-button"
  animationType="lock"
  primaryButtonText="Set up devices"
  primaryButtonId="primary-lock"
  secondaryButtonText="Go to dashboard"
  secondaryButtonId="secondary-lock"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  modalStyle="warning"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
